import React from 'react'
import useGetLiveModelWT from '../hooks/useGetLiveModelWT';
import ChartCard from './ChartCard';
import useGetTrainModelWT from '../hooks/useGetTrainModelWT';

const WTChart = ({ id, start, end, units, currTab, list, modelId, modelStatus }) => {

    const { data, loading } = useGetLiveModelWT(id, start, end, units, currTab, list);

    const { data: trainData, loading: trainLoading } = useGetTrainModelWT(id, start, end, units, currTab, list, modelId);

    let graphData = [];

    if (data && data.length > 0 && !loading) {
        graphData = [...data, ...graphData]
    }
    if (modelStatus === "OBSERVATION" && trainData && trainData.length > 0 && !trainLoading) {

        graphData = [...trainData, ...graphData]
    }

    return (
        <ChartCard
            sensor={id}
            title={"Wall Thickness"}
            loading={loading || trainLoading}
            graphdata={graphData}
            units={units}
            fixedYRangeVariables={["Predicted Wall Thickness", "Measured Wall Thickness", "Trained Model Predicted Wall Thickness"]}
        />

    )
}

export default WTChart